module.exports = __webpack_public_path__ + "static/media/home.c98d0fe5.jpg";